// extracted by mini-css-extract-plugin
export default {"point":"NumberPoint_point__Topdl","current":"NumberPoint_current__CgHf-","checked":"NumberPoint_checked__ipXJ5"};